module.exports = __webpack_public_path__ + "static/img/アセット 53@3x.0c73c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 53@3x.png
// module id = vqS9
// module chunks = 1